import { CheckboxBlankOutlineIcon } from './CheckboxBlankOutlineIcon';

/**
 * author: Google
 * id C7D0E43D-6393-429B-BDCE-B522419B7B3D
 * name checkbox-blank-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-blank-outline.svg
 * tags
 * - Form 
 */
export const MaximizeIcon = CheckboxBlankOutlineIcon;
export default MaximizeIcon